'use strict';

var jsxRuntime = require('react/jsx-runtime');
var cauldronReact = require('@deque/cauldron-react');
var react = require('react');
var billingUtils = require('@deque/billing-utils');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var modules_9d707ac1 = {"productContainer":"_productContainer_747e633b","logoContainer":"_logoContainer_747e633b","product":"_product_747e633b"};

var NavBarProductSwitcher = function (_a) {
    var currentProduct = _a.currentProduct, availableProducts = _a.availableProducts;
    var hasAvailableProducts = availableProducts && availableProducts.length;
    var currentAndAvailableProducts = hasAvailableProducts
        ? availableProducts.sort(function (a, b) { return a.name.localeCompare(b.name); })
        : [currentProduct];
    var ProductContainer = function () {
        return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("div", { className: modules_9d707ac1.logoContainer }), jsxRuntime.jsx("div", { className: modules_9d707ac1.productContainer, children: hasAvailableProducts ? (jsxRuntime.jsx("span", { className: modules_9d707ac1.product, children: currentProduct.name })) : (jsxRuntime.jsx("a", { className: modules_9d707ac1.product, href: currentProduct.url, children: currentProduct.name })) })] }));
    };
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: hasAvailableProducts ? (jsxRuntime.jsx(cauldronReact.ActionMenu, { tabIndex: -1, renderInTrigger: true, trigger: function (_a) {
                var ref = _a.ref, children = _a.children, props = __rest(_a, ["ref", "children"]);
                return (jsxRuntime.jsxs(cauldronReact.TopBarItem
                //@ts-expect-error - Type 'RefObject<HTMLButtonElement>' is not assignable to type 'Ref<HTMLLIElement> | undefined'
                , __assign({ 
                    //@ts-expect-error - Type 'RefObject<HTMLButtonElement>' is not assignable to type 'Ref<HTMLLIElement> | undefined'
                    menuItemRef: ref, tabIndex: 0, autoClickLink: false }, props, { children: [jsxRuntime.jsx(ProductContainer, {}), jsxRuntime.jsx(cauldronReact.Icon, { type: "chevron-down" }), children] })));
            }, children: jsxRuntime.jsx(cauldronReact.ActionList, { children: currentAndAvailableProducts.map(function (product) { return (jsxRuntime.jsx(cauldronReact.ActionListLinkItem, { href: product.url, children: product.name }, product.slug)); }) }) })) : (jsxRuntime.jsx(cauldronReact.TopBarItem, { children: jsxRuntime.jsx(ProductContainer, {}) })) }));
};
NavBarProductSwitcher.displayName = 'NavBarProductSwitcher';

function getProducts(axeAccountUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var res, json, products, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(axeAccountUrl, "/api/billing/v2/products"))];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = _a.sent();
                    products = json.map(function (product) { return ({
                        name: product.name,
                        slug: product.slug
                    }); });
                    return [2 /*return*/, products];
                case 3:
                    error_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error("Error fetching products: ".concat(error_1.message));
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function useProducts(axeAccountUrl) {
    var _a = __read(react.useState([]), 2), products = _a[0], setProducts = _a[1];
    react.useEffect(function () {
        var cancelled = false;
        getProducts(axeAccountUrl).then(function (data) {
            if (data && !cancelled) {
                setProducts(data);
            }
        });
        return function () {
            cancelled = true;
        };
    }, [axeAccountUrl]);
    return products;
}
function getProductBySlug(products, slug) {
    return products.find(function (product) { return product.slug === slug; });
}

//we should expose this through @billing-utils in the future
var ACTIVE_STATES = ['paid', 'trialing'];

function getBillingUser(axeAccountUrl, token) {
    return __awaiter(this, void 0, void 0, function () {
        var url, res, json, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    url = "".concat(axeAccountUrl, "/api/billing/v2/me");
                    return [4 /*yield*/, fetch(url, {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                'Content-Type': 'application/json',
                                Accept: 'application/json'
                            }
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, json];
                case 3:
                    error_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error("Error fetching billing user: ".concat(error_1.message));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function useBillingUser(axeAccountUrl, token) {
    var _a = __read(react.useState(), 2), billingUser = _a[0], setBillingUser = _a[1];
    react.useEffect(function () {
        var cancelled = false;
        getBillingUser(axeAccountUrl, token).then(function (data) {
            if (data && !cancelled) {
                setBillingUser(data);
            }
        });
        return function () {
            cancelled = true;
        };
    }, [axeAccountUrl, token]);
    return billingUser;
}
function getBillingUserAvailableProducts(currentApp, products, axeAccountUrl, billingUser, enterpriseId) {
    if (!billingUser || !axeAccountUrl || billingUser.enterprises.length === 0) {
        return [];
    }
    var subscriptionAppSlugs = [
        billingUtils.ProductSlugs.axeAuditor,
        billingUtils.ProductSlugs.axeDevToolsWatcher,
        billingUtils.ProductSlugs.axeDevToolsMobile,
        billingUtils.ProductSlugs.axeMonitor,
        billingUtils.ProductSlugs.axeReports
    ];
    var enterprise = enterpriseId
        ? billingUser.enterprises.find(function (e) { return e.id === enterpriseId; })
        : billingUser.enterprises[0];
    var subscriptionApps = subscriptionAppSlugs
        .map(function (slug) {
        var _a, _b;
        if (slug === currentApp.slug) {
            // We intentionally allow a self-link for the current product even if we can't find
            // a subscription/instance_url for it; this prevents a regression in functionality
            // in the event that we miss updating a specific user's instance_url somehow.
            return currentApp;
        }
        var name = (_b = (_a = getProductBySlug(products, slug)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        // The controlling subscription controls purchase state and the direct subscription
        // controls instance_url. Be careful; they can be different if product bundles are in
        // play.
        var controllingSubscription = billingUtils.getControllingProductSubscription(billingUser, slug); // from billing-utils
        var directSubscription = enterprise.subscriptions.find(function (s) { return s.product_slug === slug; });
        var url = directSubscription === null || directSubscription === void 0 ? void 0 : directSubscription.instance_url;
        var isActive = ACTIVE_STATES.includes(controllingSubscription === null || controllingSubscription === void 0 ? void 0 : controllingSubscription.purchase_state);
        if (isActive && url) {
            return { slug: slug, name: name, url: url };
        }
        else {
            return null;
        }
    })
        .filter(function (i) { return i !== null; });
    var availableApps = __spreadArray(__spreadArray([], __read(subscriptionApps), false), [
        {
            slug: 'axe-account',
            name: 'axe Account',
            url: axeAccountUrl
        }
    ], false);
    return availableApps;
}

exports.NavBarProductSwitcher = NavBarProductSwitcher;
exports.getBillingUserAvailableProducts = getBillingUserAvailableProducts;
exports.getProductBySlug = getProductBySlug;
exports.useBillingUser = useBillingUser;
exports.useProducts = useProducts;
